import { render, staticRenderFns } from "./OTree.vue?vue&type=template&id=a490b324"
import script from "./OTree.vue?vue&type=script&lang=js"
export * from "./OTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports